// Étape 7 (2026-11-02) : colonnes proposées à l'export (noms renvoyés par le serveur, get-export-columns).
// Mêmes traductions que les en-têtes des fichiers (Shared/Localization/ExportTexts.cs).
const exportFrColumns = {
  "Address": "Adresse",
  "Arrival Date": "Date d'arrivée",
  "Arrival Datetime": "Arrivée",
  "Availability": "Disponibilité",
  "Base Rate": "Tarif de base",
  "Base Rate Return": "Tarif de base retour",
  "Booked on": "Réservé le",
  "Booking Class": "Classe",
  "Booking Ref No Offline": "Réf. réservation hors ligne",
  "Booking Ref No.": "Réf. réservation",
  "Booking Type": "Type de réservation",
  "Box Category Name": "Catégorie de colis",
  "Box Type Name": "Type de colis",
  "Box Type Value": "Valeur du type de colis",
  "Box Volume Name": "Volume de colis",
  "Box Volume Value": "Valeur du volume",
  "Box Weight Value": "Poids",
  "Bus": "Car",
  "Bus Brand": "Marque du car",
  "Bus Model": "Modèle du car",
  "Bus Name": "Nom du car",
  "Chassis No": "N° de châssis",
  "City": "Ville",
  "ClientId": "Identifiant client",
  "Company Image URL": "Adresse du logo",
  "Company Secret Key Set": "Clé secrète définie",
  "Component Type": "Type de composant",
  "Contact Email": "E-mail de contact",
  "Country": "Pays",
  "Created On": "Créé le",
  "Date": "Date",
  "Date Of Birth": "Date de naissance",
  "Departure Date": "Date de départ",
  "Departure Datetime": "Départ",
  "Destination": "Destination",
  "Destination Name": "Destination",
  "Destination Station": "Gare d'arrivée",
  "Distance": "Distance",
  "Distance (km)": "Distance (km)",
  "Duration": "Durée",
  "Email": "E-mail",
  "First Name": "Prénom",
  "Free Bags": "Bagages gratuits",
  "Full Name": "Nom complet",
  "Gender": "Sexe",
  "Is SMS Notification Allowed": "Notifications SMS autorisées",
  "IsActive": "Actif",
  "Last Login": "Dernière connexion",
  "Last Name": "Nom",
  "Max Bags Allowed": "Bagages maximum",
  "Monetary Zone": "Zone monétaire",
  "Name": "Nom",
  "No Of Rows": "Nombre de rangées",
  "No of Stations": "Nombre de gares",
  "No of Stops": "Nombre d'arrêts",
  "No. of Baggage": "Nombre de bagages",
  "No. of Booking": "Nombre de réservations",
  "No. of Bus": "Nombre de cars",
  "No. of Passenger": "Nombre de passagers",
  "No. of Shipment": "Nombre de colis",
  "No. of Trip": "Nombre de trajets",
  "Origin Station": "Gare de départ",
  "Owner": "Propriétaire",
  "OwnerId": "Propriétaire",
  "Partner Name": "Partenaire",
  "Passenger Type": "Type de passager",
  "Phone": "Téléphone",
  "Phone Number": "Téléphone",
  "Plan": "Formule",
  "Price": "Prix",
  "Prix Bag": "Prix bagage",
  "Prix Bag Bike": "Prix bagage vélo",
  "Prix Bag Sup": "Prix bagage supplémentaire",
  "Provider Interface": "Interface du fournisseur",
  "Region": "Région",
  "Remarks": "Remarques",
  "Reporting Manager": "Responsable",
  "Roles": "Rôles",
  "Route Internal Code": "Code interne de l'itinéraire",
  "Route Name": "Itinéraire",
  "Route Type": "Type d'itinéraire",
  "Seating Model": "Plan de salle",
  "Seating Model Name": "Plan de salle",
  "Seating Model Ref": "Réf. plan de salle",
  "Seating Type": "Type de sièges",
  "Serial No": "N°",
  "Source": "Origine",
  "Source Name": "Origine",
  "Store": "Boutique",
  "Ticket Class": "Classe",
  "Ticket Ref No Offline": "Réf. billet hors ligne",
  "Ticket Ref No.": "Réf. billet",
  "TicketAmount": "Montant des billets",
  "Transport Vendor": "Transporteur",
  "Trip": "Trajet",
  "Trip Name": "Trajet",
  "Trip Reference Number": "Réf. trajet",
  "Type": "Type",
  "User Remarks": "Remarques",
  "Users": "Utilisateurs",
};

export default exportFrColumns;
